import app from './app';

// french
export default {
  app,
};
